import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import Button from 'shared/ui/Button';
import { TrashIcon } from '../../styled';
import ModalWarning from 'Common/Components/ModalWarning';
import { selectAgentList, selectAgentsSelected } from 'store/Agents/selectors';
import selectModal from 'store/modals/selectors';
import { selectAllowedByRole } from 'Hooks/usePermission/selector';
import { FEATURE_AGENTS, PERMISSION_TYPES } from 'Hooks/usePermission/permissions';
import { MODAL_AGENT_DETAIL } from 'store/modals/modals';

// Only rendered on the Runner agents tab - Cloud Agents (Security Scanners) cannot be deleted.
const DeleteButton = ({ markToDelete }) => {
  const [showWarning, setShowWarning] = useState(false);
  const agentsSelected = useSelector(selectAgentsSelected);
  const agents = useSelector(selectAgentList);
  const showDetail = useSelector((state) => selectModal(state, MODAL_AGENT_DETAIL));
  const allowedByRole = useSelector((state) => selectAllowedByRole(state, FEATURE_AGENTS, PERMISSION_TYPES.DELETE));
  const canDelete = !showDetail && agents.length > 0 && allowedByRole;
  const message = 'Please select at least one Runner';

  const handleClick = () => {
    if (canDelete) {
      if (agentsSelected.length > 0) markToDelete(null);
      else setShowWarning(true);
    }
  };

  const onClose = () => setShowWarning(false);

  return (
    <>
      <Button variant="ghost" startIcon={ <TrashIcon /> } title="Delete" ariaLabel="Delete" onClick={ handleClick } disabled={ !canDelete } />
      { showWarning && <ModalWarning onCloseCallback={ onClose } title="Delete" description={ message } /> }
    </>
  );
};

export default DeleteButton;
